export default "__VITE_ASSET__97287a9c__"